export const profilePage = {
    'profile.page.title': "{name}'s Profile | R.Toys",
    'profile.page.title.my': 'My Profile | R.Toys',
    'profile.page.description': "Check out {shortId}'s toy collection on R.Toys. Discover unique NFT and physical toys.",
    'profile.page.description.my': 'View your favorite toys, both NFT and physical. Edit your profile, add new collections, and explore the exciting world of R.Toys.',
}
